import { Create } from 'react-admin';
import { QuickReplyForm } from './index';

export const QuickReplyCreate = () => (
  <Create>
    <QuickReplyForm />
  </Create>
);
